import { render, staticRenderFns } from "./r-talk-dialog.vue?vue&type=template&id=967fc434&scoped=true"
import script from "./r-talk-dialog.vue?vue&type=script&lang=js"
export * from "./r-talk-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-talk-dialog.vue?vue&type=style&index=0&id=967fc434&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967fc434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967fc434')) {
      api.createRecord('967fc434', component.options)
    } else {
      api.reload('967fc434', component.options)
    }
    module.hot.accept("./r-talk-dialog.vue?vue&type=template&id=967fc434&scoped=true", function () {
      api.rerender('967fc434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/talk/r-talk-dialog.vue"
export default component.exports